export type RequestLoad = {
  requestId: string | undefined;
  startedTimeStamp: number | undefined;
  fulfilledTimeStamp: number | undefined;
  hasCurrentData: boolean;
  isError: boolean;
  error: unknown;
};

export type QueryResult = {
  requestId?: string;
  startedTimeStamp?: number;
  fulfilledTimeStamp?: number;
  currentData?: unknown;
  isFetching: boolean;
  isError: boolean;
  error?: unknown;
};

export function toRequestLoad(query: QueryResult): RequestLoad {
  return {
    requestId: query.requestId,
    startedTimeStamp: query.startedTimeStamp,
    fulfilledTimeStamp: query.fulfilledTimeStamp,
    hasCurrentData: query.currentData !== undefined && !query.isFetching,
    isError: query.isError,
    error: query.error,
  };
}

export function requestDurationMs({ startedTimeStamp, fulfilledTimeStamp }: RequestLoad): number | undefined {
  return startedTimeStamp === undefined || fulfilledTimeStamp === undefined
    ? undefined
    : fulfilledTimeStamp - startedTimeStamp;
}

export type LoadFailure = { outcome: 'failed'; requestId: string; startedTimeStamp: number; error: unknown };

export type LoadOutcome =
  | { outcome: 'pending' }
  | { outcome: 'loaded'; requestId: string; durationMs: number }
  | LoadFailure;

export function loadOutcome(load: RequestLoad): LoadOutcome {
  const { requestId, startedTimeStamp, hasCurrentData, isError, error } = load;
  if (requestId === undefined || startedTimeStamp === undefined) {
    return { outcome: 'pending' };
  }
  if (isError) {
    return { outcome: 'failed', requestId, startedTimeStamp, error };
  }
  const durationMs = requestDurationMs(load);
  return hasCurrentData && durationMs !== undefined
    ? { outcome: 'loaded', requestId, durationMs }
    : { outcome: 'pending' };
}
